import { useCallback, useState } from "react";
interface IOutlineImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
  name: string;
  imageSize?: number;
  containerSize?: number;
}
export default function OutlineImageWithFallback({
  src,
  alt,
  className,
  name,
  containerSize = 40,
  imageSize = 40,
}: IOutlineImageWithFallbackProps) {
  const [imageError, setImageError] = useState(false);
  const handleImageError = useCallback(() => {
    setImageError(true);
  }, []);
  return (
    <div
      className={`bg-cover bg-white flex items-center justify-center p-3 border border-border rounded-[6px] ${className}`}
      style={{
        width: containerSize,
        height: containerSize,
        objectFit: "contain",
      }}
    >
      {/* Logo veya fallback göster */}
      {imageError || !src ? (
        <CompanyLogoFallback name={name} size={imageSize} />
      ) : (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={handleImageError}
          style={{
            width: imageSize,
            minWidth: imageSize,
            maxHeight: imageSize,
            objectFit: "contain",
          }}
        />
      )}
    </div>
  );
}

interface ImageFallbackProps {
  name: string;
  size?: number;
}

function CompanyLogoFallback({ name, size = 40 }: ImageFallbackProps) {
  // Company isminin ilk harfini al ve büyük harfe çevir
  const firstLetter = name?.charAt(0)?.toUpperCase() || "?";

  return (
    <div
      className={`flex items-center justify-center bg-white text-gray-700 font-semibold`}
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        fontSize: size * 0.4, // Harfin boyutu container'ın %40'ı kadar olsun
        borderRadius: "6px",
      }}
    >
      {firstLetter}
    </div>
  );
}
